import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbDataValueRenderer } from "abreact/data/AbDataValueRenderer";
import * as AbFormHooks from "abreact/form/AbFormHooks";
import { AbTextArea } from "abreact/input/AbTextArea";
import { StringUtils } from "abweb/utils/StringUtils";
import * as React from "react";
export function AbMultiLinePlainStringDataValueInput(props) {
  const viewModel = AbFormHooks.useDataValueInputViewModel("ab-multi-line-plain-string-data-value-input", props);
  if (!viewModel) {
    return null;
  }
  const currentValue = viewModel.currentValue;
  const name = props.name ?? props.accessor.name;
  const onChange = newString => {
    viewModel.changeValue(newString !== "" ? newString : null);
  };

  // Render as inactive if the component is editable and being shown in edit mode, but yet it isn't editing.
  // This means that the user is trying to edit the data value, but they don't have editing permissions.
  const isInactive = !viewModel.isEditing && !props.readOnly && viewModel.isInEditMode;
  return !viewModel.isEditing ? currentValue != null && props.valueRenderer ? /*#__PURE__*/React.createElement("div", viewModel.readOnlyProps, props.valueRenderer(currentValue)) : /*#__PURE__*/React.createElement(AbDataValueRenderer, _extends({}, viewModel.readOnlyProps, {
    subject: props.subject,
    accessor: props.accessor,
    currentValue: currentValue,
    inactive: isInactive
  })) : /*#__PURE__*/React.createElement(AbTextArea, _extends({}, viewModel.inputProps, {
    name: name,
    value: StringUtils.emptyIfNull(currentValue),
    resizable: true,
    onChange: onChange
  }));
}
//# sourceMappingURL=AbMultiLinePlainStringDataValueInput.js.map
